import styled from 'styled-components/macro';


export const StyledButton = styled.button`
    display:inline-flex;
    cursor:pointer;
    border: 2px solid #fff;
    padding-top:10px;
    padding-bottom:10px;
    padding-right:20px;
    padding-left:20px;
    background-color:transparent;
    color:#FFFFFF;
    transition: all .3s;
    &:hover {
        background-color: #fff;
        color:#000;
    }
`;

